import React from 'react';
import { StyledBadge } from './StatusBadge.styles';
import { INTEGRATION_STATUS_LABELS } from '../../constants/integrationStatus';

const StatusBadge = ({ status, children }) => (
  <StyledBadge status={status}>
    {children || INTEGRATION_STATUS_LABELS[status] || status}
  </StyledBadge>
);

export default StatusBadge;
